import React from "react";
import SwiperCore, { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.scss";
import stylesPc from "./ChannelSlideGroup.module.css";
import stylesSp from "./ChannelSlideGroup_SP.module.css";
import { IsDevice } from "../../../components/function/useDeviceFlag";
import "./navigationButton.css";
import PuiTooltip from "../../../components/elements/PuiTooltip ";
import SlideNextIcon from "../images/SlideNextIcon";
import SlidePrevIcon from "../images/SlidePrevIcon";
import { Program, RelatedVideo, Video } from "../../../stores/program/model/Program";
import { Modal } from "@material-ui/core";
import ProgramDetail from "../modal/ProgramDetail";

SwiperCore.use([Navigation]);

// スライドの型定義
export interface ChannelSlideGroupProps {
    // id
    id: string;
    // 一列に表示させる画像数
    displayNum: number;
    // 画像のループ切り替え
    needLoop: boolean;
    // チャンネルリスト
    ChannelList: Program[];
}

export default function ChannelSlideGroup({ ...props }: ChannelSlideGroupProps) {
    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : stylesSp;

    const [open, setOpen] = React.useState(false);
    const [selectedVideo, setSelectedVideo] = React.useState<Video>();
    const [videos, setVideos] = React.useState<Video[]>();
    const [related, setRelated] = React.useState<RelatedVideo[]>();
    const [title, setTitle] = React.useState("");
    const [des, setDes] = React.useState("");

    const handleOpen = (value: any) => {
        setOpen(true);

        // セレクトビデオエリアの画像変更
        const selectId: string = value.target.id;

        // プログラムをクリック
        if (props.ChannelList !== undefined) {
            for (let i = 0; i < props.ChannelList.length; i++) {
                if (props.ChannelList[i].id === selectId) {
                    // フォーカスビデオをセット
                    setSelectedVideo(selectVideo(props.ChannelList[i].videos));
                    // その他のパラメータをセット
                    setVideos(props.ChannelList[i].videos);
                    setRelated(props.ChannelList[i].relatedVideos);
                    setDes(props.ChannelList[i].description);
                    setTitle(props.ChannelList[i].title);
                }
            }
        }
    };

    // フォーカスされたビデオを決める
    const selectVideo = (videos: Video[]) => {
        if (videos.length === 1) {
            return videos[0];
        }

        if (videos.length > 1) {
            // 最新履歴の日付をとる（時間）
            const latestDate = Math.max(
                ...videos.map((item) => {
                    if (item.viewingActivities.length > 0) {
                        return Date.parse(item.viewingActivities[0].created);
                    } else {
                        return -1;
                    }
                })
            );

            for (let j = 0; j < videos.length; j++) {
                // 視聴していないビデオをスキップ
                if (videos[j].viewingActivities.length === 0) {
                    continue;
                }

                const date = Date.parse(videos[j].viewingActivities[0].created);
                const isFinished = videos[j].viewingActivities[0].isFinished;

                if (date === latestDate && !isFinished) {
                    return videos[j];
                } else if (date === latestDate && isFinished) {
                    if (j === videos.length - 1) {
                        return videos[0];
                    }
                    return videos[j + 1];
                } else {
                    return videos[0];
                }
            }
        }
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div style={{ position: "relative" }}>
            {((IsDevice("desktop") && props.ChannelList.length > 5) ||
                (IsDevice("ipad") && props.ChannelList.length > 3) ||
                (IsDevice("iphone") && props.ChannelList.length > 2)) && (
                <>
                    <div
                        className={`${styles.swiperButtonDiv} swiper-channel-next-${props.id} ${styles.swiperRight} swiper-channel-next swiper-button-disabled`}
                        style={{
                            height: IsDevice("ipad") ? "calc(17vw - 5px)" : "none",
                        }}
                    >
                        <div className={styles.swiperButton}>
                            <SlideNextIcon />
                        </div>
                    </div>
                    <div
                        className={`${styles.swiperButtonDiv} swiper-channel-prev-${props.id} ${styles.swiperLeft} swiper-channel-prev swiper-button-disabled`}
                        style={{
                            height: IsDevice("ipad") ? "calc(17vw - 5px)" : "none",
                        }}
                    >
                        <div className={styles.swiperButton}>
                            <SlidePrevIcon />
                        </div>
                    </div>
                </>
            )}
            <Swiper
                spaceBetween={15}
                slidesPerView={props.displayNum}
                loop={
                    props.needLoop
                        ? props.ChannelList.length >= props.displayNum
                            ? true
                            : false
                        : false
                }
                loopFillGroupWithBlank={
                    props.needLoop
                        ? props.ChannelList.length >= props.displayNum
                            ? false
                            : true
                        : true
                }
                navigation={{
                    nextEl: `.swiper-channel-next-${props.id}`,
                    prevEl: `.swiper-channel-prev-${props.id}`,
                }}
            >
                {props.ChannelList.map((row, index) => (
                    <SwiperSlide key={`${props.id}-${index}`}>
                        <div className={styles.slideDiv}>
                            <img
                                id={row.id}
                                src={row.imageUrl}
                                onError={(e) =>
                                    (e.currentTarget.src =
                                        require("../../../assets/image/NoImage.jpg").default)
                                }
                                className={styles.slideImg}
                                alt={row.id}
                                onClick={handleOpen}
                            />
                        </div>
                        <div
                            id={row.id}
                            data-tip={row.title}
                            data-for="record"
                            className={styles.slideTitle}
                            onClick={handleOpen}
                        >
                            {row.title}
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
            {/* Tooltip */}
            <PuiTooltip id={"record"} />
            <Modal
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
                className={styles.modal}
                open={open}
                onClose={handleClose}
                closeAfterTransition
            >
                <ProgramDetail
                    in={open}
                    onClose={handleClose}
                    title={title}
                    description={des}
                    episodelist={videos}
                    selected={selectedVideo}
                    related={related}
                />
            </Modal>
        </div>
    );
}
